import axios from "axios";

const handle401 = (error: any) => {
  if (error.response?.status === 401) {
    const currentPath = window.location.pathname;
    if (currentPath !== "/login") {
      sessionStorage.clear();
      window.location.href = "/login";
    }
  }
  return Promise.reject(error);
};

export const setupGlobalAxiosInterceptors = () => {
  axios.interceptors.response.use(response => response, handle401);
};
